export default __webpack_public_path__ + "static/media/pea.065a9762.png";